import type { NetworkError } from '@confluence/network';
import { BadStatusError, cfetch } from '@confluence/network';

type SiteAdminsResponse = {
	siteAdminIds: string[];
};

export type ServiceError = {
	name: string;
	message: string;
	status?: number;
	traceId?: string;
};

export const fetchSiteAdmins = async (cloudId: string): Promise<SiteAdminsResponse> => {
	return cfetch(`/gateway/api/growth/trial-end-lock-screen/get-site-admins?cloudId=${cloudId}`)
		.then((result) => result.json())
		.catch((error: NetworkError) => {
			const errorResponse: ServiceError = {
				name: error.name,
				message: error.message,
			};
			if (error instanceof BadStatusError) {
				errorResponse.status = error.response.status;
				errorResponse.traceId = error.response.headers.get('X-Trace-Id') || undefined;
			}

			return Promise.reject(errorResponse);
		});
};
